import React, { Component } from "react";
import AsiaItems from "./AsiaItems";
import { Route, Switch } from "react-router-dom";
import ItemInfo from '../ItemInfo'
import asia from '../Asia'

export default class Asia extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const asiaData = asia.map(item => item)
    return (
      <React.Fragment>
        
        <Switch>
          <Route exact path="/asia" component={AsiaItems} />
          <Route path={asiaData.link} component={ItemInfo}/>
        </Switch>
      </React.Fragment>
    );
  }
}
